import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperComponent } from './stepper.component';
import { ImageAtomModule } from '../image/image.module';


@NgModule({
  declarations: [StepperComponent],
  imports: [
    CommonModule,
    ImageAtomModule
  ],
  exports: [StepperComponent]
})
export class StepperAtomModule { }
